"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const getIconComponent = (iconProp, iconSize, fontWeight) => {
    if (!iconProp)
        return null;
    const iconStyle = {
        fontSize: iconSize,
        fontWeight: fontWeight,
    };
    if (typeof iconProp === "string") {
        return react_1.default.createElement("i", { className: `mdi mdi-${iconProp}`, style: iconStyle });
    }
    return (react_1.default.createElement("i", { className: (0, classnames_1.default)(`mdi mdi-${iconProp.name}`, iconProp.className), style: iconStyle }));
};
const getSizeStyles = (size) => {
    const sizes = {
        xs: {
            borderRadius: "4px",
            paddingX: "6px",
            paddingY: "2px",
            fontSize: "12px",
            iconSize: "12px",
            height: "18px",
        },
        sm: {
            borderRadius: "6px",
            paddingX: "10px",
            paddingY: "4px",
            fontSize: "14px",
            iconSize: "14px",
            height: "20px",
        },
        md: {
            borderRadius: "6px",
            paddingX: "12px",
            paddingY: "6px",
            fontSize: "14px",
            iconSize: "16px",
            // height: "24px",
        },
        base: {
            borderRadius: "6px",
            paddingX: "14px",
            paddingY: "8px",
            fontSize: "14px",
            iconSize: "16px",
            height: "32px",
        },
        lg: {
            borderRadius: "6px",
            paddingX: "16px",
            paddingY: "11px",
            fontSize: "14px",
            iconSize: "18px",
            height: "40px",
        },
        xl: {
            borderRadius: "6px",
            paddingX: "20px",
            paddingY: "10px",
            fontSize: "20px",
            iconSize: "20px",
            height: "40px",
        },
    };
    return sizes[size];
};
function Button(_a) {
    var { loading = false, size = "md", startIcon, endIcon, width = "auto", fontWeight = "bold", margin, tooltip, disabled = false, className, children, style } = _a, props = __rest(_a, ["loading", "size", "startIcon", "endIcon", "width", "fontWeight", "margin", "tooltip", "disabled", "className", "children", "style"]);
    const sizeStyles = getSizeStyles(size);
    const { iconSize, paddingX, paddingY } = sizeStyles, restSizeStyles = __rest(sizeStyles, ["iconSize", "paddingX", "paddingY"]);
    const styles = Object.assign(Object.assign({ whiteSpace: "nowrap", width: width === "full"
            ? "100%"
            : typeof width === "number"
                ? `${width}px`
                : "auto", margin,
        fontWeight, padding: `${paddingY} ${paddingX}` }, restSizeStyles), style);
    return (react_1.default.createElement(react_bootstrap_1.Button, Object.assign({ as: "button", className: (0, classnames_1.default)("d-flex align-items-center justify-content-center whitespace-nowrap", className), disabled: disabled || loading, title: tooltip, style: styles }, props), loading ? (react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm" })) : (react_1.default.createElement(react_1.default.Fragment, null,
        getIconComponent(startIcon, iconSize, fontWeight),
        children,
        getIconComponent(endIcon, iconSize, fontWeight)))));
}
exports.default = Button;
